import { cva } from 'class-variance-authority'

export const articleHeaderVariants = {
  base: cva(
    [
      'grid',
      'grid-cols-subgrid',
      'gap-y-6',
      'mb-1',
      'full-width-content',
      'dark:text-white',
    ],
    {
      variants: {
        hasImage: {
          true: ['2xl:col-start-2 2xl:col-span-7'],
          false: [],
        },
      },
    },
  ),

  title: cva(['flex', 'items-center', 'justify-center', 'md:justify-start', 'text-center', 'md:text-start', 'col-span-full'], {
    variants: {
      hasImage: {
        true: ['2xl:col-span-7'],
        false: [],
      },
      hasShape: {
        true: [],
        false: [],
      },
      template: {
        'info-page': [],
        'standard': [],
        'testimonial': [],
      },
    },
    compoundVariants: [
      {
        hasImage: false,
        template: 'info-page',
        class: ['md:mt-10'],
      },
      {
        hasShape: true,
        template: 'info-page',
        class: ['lg:col-start-2'],
      },
      {
        hasShape: false,
        template: 'info-page',
        class: ['lg:col-start-3'],
      },
    ],
  }),

  leadParagraph: cva(['col-span-4', 'lg:col-span-5'], {
    variants: {
      hasImage: {
        true: [],
        false: [],
      },
      hasShape: {
        true: [],
        false: [],
      },
      template: {
        'info-page': ['text-center', 'md:text-start', '2xl:col-span-7'],
        'standard': [],
        'testimonial': [],
      },
    },
    compoundVariants: [
      {
        hasImage: true,
        template: 'info-page',
        class: ['2xl:col-start-1'],
      },
      {
        hasImage: false,
        hasShape: false,
        template: 'info-page',
        class: ['2xl:col-start-3'],
      },
      {
        hasShape: false,
        template: 'info-page',
        class: ['lg:col-start-3'],
      },
      {
        hasShape: true,
        template: 'info-page',
        class: ['lg:col-start-2', '2xl:col-start-2'],
      },
    ],
  }),

  imageWrapper: cva(['hidden', '2xl:block'], {
    variants: {
      template: {
        'info-page': ['col-span-3', '-mx-[--gutter]'],
        'standard': ['col-span-4', 'min-w-[670px]'],
        'testimonial': ['col-span-4', 'min-w-[670px]'],
      },
    },
  }),

  image: cva(['object-cover'], {
    variants: {
      template: {
        'info-page': ['aspect-square', 'size-full'],
        'standard': ['min-h-[535px]', 'rounded-r-2xl'],
        'testimonial': ['min-h-[535px]', 'rounded-r-2xl'],
      },
    },
  }),
}
